import {
  SET_PLD_CATALOGS,
  SET_PLD_CATALOG_LOADING,
  SET_PLD_CATALOG_ERROR,
  CLEAR_PLD_CATALOGS,
} from 'redux/constants/pldCatalogs';

export const initialState = {
  isLoading: false,
  error: null,
  catalogData: {},
};

function pldCatalogsReducer(state = initialState, action) {
  const { payload = {}, type } = action;

  switch (type) {
    default:
      return state;

    case SET_PLD_CATALOGS:
      return {
        ...state,
        catalogData: payload.catalogData,
        error: null,
      };

    case SET_PLD_CATALOG_LOADING:
      return {
        ...state,
        isLoading: payload.isLoading,
      };

    case SET_PLD_CATALOG_ERROR:
      return {
        ...state,
        error: payload.error,
      };

    case CLEAR_PLD_CATALOGS:
      return initialState;
  }
}

export default pldCatalogsReducer;
